export const RESET_BARCODE_PRODUCT = '@@barcode/product/RESET_BARCODE_PRODUCT';
export const FETCH_BARCODE_PRODUCT = '@@barcode/product/FETCH_BARCODE_PRODUCT';
export const FETCH_BARCODE_PRODUCT_SUCCESS =
  '@@barcode/product/FETCH_BARCODE_PRODUCT_SUCCESS';
export const FETCH_BARCODE_PRODUCT_FAIL =
  '@@barcode/product/FETCH_BARCODE_PRODUCT_FAIL';
